var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.access.report_discount)?_c('v-reports',{attrs:{"headers":_vm.headers,"update":_vm.update,"data":_vm.data,"numPages":_vm.numPages,"data_loading":_vm.data_loading},on:{"change-pagination":_vm.changePagination},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_c('error404')
}
var staticRenderFns = []

export { render, staticRenderFns }